import Http from '../http';

const prefix = '/default-item';

export const getDefaultItems = () => {
  // return Http.authApi().get(`${prefix}`);
  return Http.authApi().get(`v2${prefix}`);
};

export const getDefaultItem = id => {
  return Http.authApi().get(`${prefix}/${id}`);
};

export const updateDefaultItem = (item, encrypted_id) => {
  return Http.authApi().put(`${prefix}/${encrypted_id}`, item);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/defaultItem.js